// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-user-container {
  padding: 20px;
  display: grid;
  grid-template-rows: 30px 1fr 60px;
  height: 490px;
  grid-row-gap: 20px;
  background-color: white;
}
.invite-user-container .invite-user-email-content {
  margin-top: 20px;
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  outline: none;
  padding: 10px;
}

.create-user-fields {
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  row-gap: 10px;
}
.create-user-fields .create-user-input {
  border: 1px solid #cccccc;
  background-color: #f1f1f1;
  border-radius: 4px;
  font-size: 16px;
  padding: 10px;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/Users/CreateInternalUser/CreateInternalUser.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,iCAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;AACD;AACC;EACC,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAGA;EACC,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;AAAD;AAEC;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;AAAF","sourcesContent":[".invite-user-container {\n\tpadding: 20px;\n\tdisplay: grid;\n\tgrid-template-rows: 30px 1fr 60px;\n\theight: 490px;\n\tgrid-row-gap: 20px;\n\tbackground-color: white;\n\n\t.invite-user-email-content {\n\t\tmargin-top: 20px;\n\t\tborder: 1px solid #D3E1ED;\n\t\tborder-radius: 5px;\n\t\toutline: none;\n\t\tpadding: 10px;\n\t}\n}\n\n.create-user-fields {\n\twidth: 100%;\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\trow-gap: 10px;\n\n\t.create-user-input {\n\t\tborder: 1px solid #cccccc;\n\t\tbackground-color: #f1f1f1;\n\t\tborder-radius: 4px;\n\t\tfont-size: 16px;\n\t\tpadding: 10px;\n\t\toutline: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
